import {
    Collections,
    CustomClaims,
    LoggedUser,
    LoggedUserDefault,
    Role,
    useCollection,
    UserPrivateInfo,
    UserPrivateInfoDefault,
} from "api";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useFirebase } from "react-redux-firebase";
import { RootState } from "redux/model";
import { LoggedUserContext } from "ui/componentes/LoggedUserContext/LoggedUserContext";

const LoggedUserProvider = ({ children }) => {
    const { auth, profile } = useSelector((state: RootState) => state.firebase);

    const [customClaims, setCustomClaims] = useState<CustomClaims>(
        LoggedUserDefault.customClaims
    );

    const privateInfo = useCollection<UserPrivateInfo>({
        collection: Collections.USERS_PRIVATE_INFO,
        doc: auth.uid || "",
        storeAs: "privateInfoLoggedUser",
    });

    const roles = useCollection<Role[]>({
        collection: Collections.USERS_ROLES,
        doc: auth.uid || "",
        storeAs: "rolesLoggedUser",
    });

    const firebase = useFirebase();

    useEffect(() => {
        firebase
            .auth()
            .currentUser?.getIdTokenResult(true)
            .then((tokenReult) => {
                const { emailVerified, lastLoginAt, valid } = tokenReult.claims;
                setCustomClaims((oldCustomClaims) => ({
                    ...oldCustomClaims,
                    emailVerified,
                    lastLoginAt,
                    valid,
                }));
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.uid]);

    const loggedUser: LoggedUser = {
        ...LoggedUserDefault,
        ...profile,
        id: auth.uid,
        customClaims,
        privateInfo: privateInfo || { ...UserPrivateInfoDefault },
        roles: roles ? roles["roles"] || [] : [],
        isAdmin: roles ? (roles["roles"] || []).includes(Role.ADMIN) : false,
    };

    return (
        <LoggedUserContext.Provider value={loggedUser}>
            {children}
        </LoggedUserContext.Provider>
    );
};

export { LoggedUserProvider };
